import Vue from 'vue'
import Vuex from 'vuex'
import {cks} from '../utils/tool'
import appConfig from './modules/appConfig';
import redirect from './modules/redirect';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const PERSIST_KEY = 'web-power-bank-vuex-v2'
const LEGACY_PERSIST_KEYS = ['vuex', 'web-power-bank-vuex']

function safeJsonParse(str) {
    try {
        return JSON.parse(str)
    } catch (_) {
        return null
    }
}

function isTooLargePersistedValue(raw) {
    return typeof raw === 'string' && raw.length > 200000
}

function pickPersistedState(state) {
    return {
        token: state && state.token,
        redirect: state && state.redirect,
        appConfig: state && state.appConfig
            ? {
                device_code: state.appConfig.device_code,
                internal_id: state.appConfig.internal_id,
            }
            : undefined,
    }
}

export default new Vuex.Store({
    state: {
        token: cks.get('token'),
        user_info_collection: [],
        is_borrow: undefined,
        billing_rule: {},
        loading: false,
        toast: '',
        notifications: [],
        repayment_info: {},
        order_info: {},
        bind_payment_context: undefined,
        highlight_card_id: undefined,
        highlight_payment_method: undefined,
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
            if (token) {
                cks.set('token', token, {expires: 30})
            } else {
                cks.remove('token')
            }
        },
        SET_USER_INFO_COLLECTION: (state, v) => {
            state.user_info_collection = v
        },
        SET_IS_BORROW: (state, v) => {
            state.is_borrow = v
        },
        SET_ORDER_INFO: (state, v) => {
            state.order_info = v
        },
        SET_REPAYMENT_INFO: (state, v) => {
            state.repayment_info = v
        },
        SET_BILLING_RULE: (state, v) => {
            state.billing_rule = v
        },
        showLoading(state) {
            state.loading = true
        },
        hideLoading(state) {
            state.loading = false
        },
        toast(state, toastTxt) {
            state.toast = toastTxt
        },
        PUSH_NOTIFICATION(state, notification) {
            state.notifications.push(notification)
        },
        REMOVE_NOTIFICATION(state, id) {
            state.notifications = state.notifications.filter(item => item.id !== id)
        },
        CLEAR_NOTIFICATIONS(state) {
            state.notifications = []
        },
        SET_BIND_PAYMENT_CONTEXT(state, v) {
            state.bind_payment_context = v
        },
        SET_HIGHLIGHT_CARD_ID(state, v) {
            state.highlight_card_id = v
        },
        SET_HIGHLIGHT_PAYMENT_METHOD(state, v) {
            state.highlight_payment_method = v
        },
    },
    actions: {
        setToken({commit}, token) {
            commit('SET_TOKEN', token)
        },
        setUserInfoCollection({commit}, v) {
            commit('SET_USER_INFO_COLLECTION', v)
        },
        setIsBorrow({commit}, is_borrow) {
            commit('SET_IS_BORROW', is_borrow)
        },
        setOrderInfo({commit}, order_info) {
            commit('SET_ORDER_INFO', order_info)
        },
        setRepaymentInfo({commit}, repayment_info) {
            commit('SET_REPAYMENT_INFO', repayment_info)
        },
        setBillingRule({commit}, billing_rule) {
            commit('SET_BILLING_RULE', billing_rule)
        },
        setBindPaymentContext({commit}, v) {
            commit('SET_BIND_PAYMENT_CONTEXT', v)
        },
        setHighlightCardId({commit}, v) {
            commit('SET_HIGHLIGHT_CARD_ID', v)
        },
        setHighlightPaymentMethod({ commit }, v) {
            commit('SET_HIGHLIGHT_PAYMENT_METHOD', v)
        },
    },
    modules: {
        appConfig,
        redirect
    },
    getters: {
        token: state => state.token,
        billing_rule: state => state.billing_rule,
        user_info_collection: state => state.user_info_collection,
        is_borrow: state => state.is_borrow,
        order_info: state => state.order_info,
        repayment_info: state => state.repayment_info,
        loading: state => state.loading,
        toast: state => state.toast,
        notifications: state => state.notifications,
        bind_payment_context: state => state.bind_payment_context,
        highlight_card_id: state => state.highlight_card_id,
        highlight_payment_method: state => state.highlight_payment_method,
    },
    plugins: [createPersistedState({
        key: PERSIST_KEY,
        paths: [
            'token',
            'redirect',
            'appConfig.device_code',
            'appConfig.internal_id'
        ],
        getState(key, storage) {
            const raw = storage.getItem(key)
            if (raw) {
                if (isTooLargePersistedValue(raw)) {
                    storage.removeItem(key)
                    return undefined
                }
                const parsed = safeJsonParse(raw)
                if (parsed) return parsed
                storage.removeItem(key)
            }

            for (const legacyKey of LEGACY_PERSIST_KEYS) {
                const legacyRaw = storage.getItem(legacyKey)
                if (!legacyRaw) continue
                if (isTooLargePersistedValue(legacyRaw)) {
                    storage.removeItem(legacyKey)
                    continue
                }
                const legacyParsed = safeJsonParse(legacyRaw)
                if (!legacyParsed) {
                    storage.removeItem(legacyKey)
                    continue
                }
                const migrated = pickPersistedState(legacyParsed)
                try {
                    storage.setItem(key, JSON.stringify(migrated))
                } catch (_) {}
                storage.removeItem(legacyKey)
                return migrated
            }
            return undefined
        },
    })]
})
